"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customerErrorHandling = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Alert = _interopRequireDefault(require("vf-comps/build/components/molecules/alerts/Alert"));

var _searchActions = require("../actions/searchActions");

var _timeOutError = _interopRequireDefault(require("../components/timeOutError"));

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AlertWrapper = function AlertWrapper(_ref) {
  var msg = _ref.msg,
      msgKey = _ref.msgKey;
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _searchActions.sendTags)({
      taggingId: 'CUSTOMER_SEARCH_WIDGET_4',
      taggingType: 'link',
      taggingValue: {
        page_error: msg
      }
    }));
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Alert.default, {
    severity: "critical",
    text: msg,
    "data-testid": "alert-".concat(msgKey)
  });
};

var customerErrorHandling = function customerErrorHandling(customerResponseError, t, dispatch) {
  var statusCode = customerResponseError === null || customerResponseError === void 0 ? void 0 : customerResponseError.status;
  var NOT_FOUND = 404,
      INVALID = 400,
      NOT_AUTHORIZED = 401,
      FORBIDDEN = 403,
      LARGE_CIF = 422,
      TIME_OUT = 408;
  var isNotFound = statusCode === NOT_FOUND;
  var isInvalid = statusCode === INVALID;
  var msg;

  switch (statusCode) {
    case NOT_FOUND:
    case INVALID:
      msg = isNotFound || isInvalid ? 'customerNotFound' : 'notAuthorized';
      return /*#__PURE__*/_react.default.createElement(AlertWrapper, {
        msg: t(msg),
        msgKey: msg
      });

    case NOT_AUTHORIZED:
    case FORBIDDEN:
      dispatch((0, _searchActions.setError)(statusCode));
      msg = 'notAuthorized';
      return /*#__PURE__*/_react.default.createElement(AlertWrapper, {
        msg: t(msg),
        msgKey: msg
      });

    case TIME_OUT:
      return /*#__PURE__*/_react.default.createElement(_timeOutError.default, {
        open: "true"
      });

    case LARGE_CIF:
      return /*#__PURE__*/_react.default.createElement(_Alert.default, {
        type: "large",
        severity: "critical",
        text: "".concat(t('cifErrorMsg'))
      });

    default:
      msg = 'somethingWrong';
      return /*#__PURE__*/_react.default.createElement(AlertWrapper, {
        msg: t(msg),
        msgKey: msg
      });
  }
};

exports.customerErrorHandling = customerErrorHandling;